import BaseIconSvg from '@/components/bases/BaseIconSvg';
import FormCreateEmr from '@/screens/CreateEmr/FormCreateEmr';
import useCreateEmr from '@/screens/CreateEmr/store';
import { useQuickModal } from '@/utils/quickModal';
import { Button, Tooltip } from 'antd';
import * as React from 'react';

export interface ICreateEmrProps {}

export default function CreateEmr(props: ICreateEmrProps) {
  useCreateEmr;
  const { quickModal, quickModalContext } = useQuickModal();
  const reset = useCreateEmr((s) => s.reset);

  const clickCreate = () => {
    quickModal.custom({
      title: 'Thêm mới dữ liệu',
      width: '800px',
      mask: true,
      afterClose() {
        reset();
      },
      content: <FormCreateEmr />,
    });
  };

  return (
    <>
      <Tooltip title={'Thêm mới'}>
        <Button className="h-full bg-white border-none shadow" onClick={() => clickCreate()}>
          <BaseIconSvg src="/icons/Large/Plus - icon.svg" />
        </Button>
      </Tooltip>
      {quickModalContext}
    </>
  );
}
